var WorkCookies = (function () {

    var setAuthToken = function (value) {
        return CookieHelper.set('token', value);
    }

    var getAuthToken = function () {
        return CookieHelper.get('token');
    }

    var removeAuthToken = function () {
        return CookieHelper.remove('token');
    }

    var setWebsocket = function (value) {
        return CookieHelper.set('workClientConnected', value);
    }

    var getWebsocket = function () {
        return CookieHelper.get('workClientConnected');
    }

    var removeWebsocket = function () {
        return CookieHelper.remove('workClientConnected');
    }

    var setLanguage = function (value) {
        let date = (new Date()).setFullYear(date.getFullYear() + 1);
        let expireString = date.toUTCString();

        return CookieHelper.set('active-language', value, expireString);
    }

    var getLangugage = function () {
        return CookieHelper.get('active-language');
    }

    var removeLanguage = function () {
        return CookieHelper.remove('active-language');
    }

    var CookieHelper = (function () {
        /**
         * @param {String} key
         * @param {*} value
         * @param expireTimes
         */
        var set = function (key, value, expireTimes = undefined) {
            window.$cookies.set(key, value, expireTimes);
        }

        /**
         * @param {String} key
         */
        var remove = function (key) {
            window.$cookies.remove(key);
        }

        /**
         * @param {String} key
         * @returns {*}
         */
        var get = function (key) {
            return window.$cookies.get(key);
        }

        return {
            set: set,
            remove: remove,
            get: get,
        }
    }());

    return {
        setAuthToken: setAuthToken,
        getAuthToken: getAuthToken,
        removeAuthToken: removeAuthToken,
        setWebsocket: setWebsocket,
        getWebsocket: getWebsocket,
        removeWebsocket: removeWebsocket,
        setLanguage: setLanguage,
        getLangugage: getLangugage,
        removeLanguage: removeLanguage,
    }
}());

export default WorkCookies;
